export default __webpack_public_path__ + "static/snowmobile-cee3c99cdef62750ed593c969385641a.jpg";